<template>
  <div>
    <v-row>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          background-color="grey lighten-4"
          v-model="searchParams.date_start"
          label="Data Inicial"
        />
      </v-col>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          background-color="grey lighten-4"
          v-model="searchParams.date_end"
          label="Data Final"
        />
      </v-col>
      <v-col md="4">
        <company-select
          chips
          multiple
          v-model="searchParams.company_ids"
          :item-value="(val) => val.id"
          :itemText="(val) => val.short_name"
          solo
          flat
          background-color="grey lighten-4"
          :dense="false"
        />
      </v-col>
      <v-col md="2">
        <v-btn
          color="primary"
          block
          large
          @click="select(1)"
          :loading="isLoading"
        >
          <v-icon left>mdi-magnify</v-icon>
          Pesquisar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="6">
        <app-text-search-field
          label="Pesquisar por produto"
          @input="handleSearchInput($event)"
          :loading="isLoading"
        />
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col>
        <v-card color="grey lighten-4" elevation="0" class="fill-height">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Quantidade a Entregar
              <br />
              <b class="text-h4">
                {{ $format.decimal(totals.total_quantity_to_delivery || 0) }}
              </b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card elevation="0" dark class="fill-height">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total Líquido
              <br />
              <b class="text-h4">
                R$ {{ $format.decimal(totals.total_net_total || 0) }}
              </b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card color="primary" dark elevation="0" class="fill-height">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Preço à Vista Total
              <br />
              <b class="text-h4">
                R$ {{ $format.decimal(totals.total_net_price_cash_total || 0) }}
              </b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col>
        <v-card flat color="grey lighten-4">
          <v-card-title class="d-flex justify-space-between mb-4 pt-5">
            <span class="text-subtitle-1">
              Produtos por Venda para Entrega
            </span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              class="grey lighten-4"
              :headers="headers"
              :items="products.data"
              hide-default-footer
              :items-per-page="-1"
              disable-sort
            >
              <template v-slot:item.product="{ item }">
                <div class="d-flex align-center py-2">
                  <div>
                    <div class="font-weight-medium">
                      {{ item.product_code }} - {{ item.product_short_name }}
                    </div>
                    <div class="text-caption text--secondary">
                      {{ item.product_name }}
                    </div>
                  </div>
                </div>
              </template>

              <template v-slot:item.total_quantity_to_delivery="{ item }">
                {{ $format.decimal(item.total_quantity_to_delivery) }}
              </template>

              <template v-slot:item.total_quantity_delivered="{ item }">
                {{ $format.decimal(item.total_quantity_delivered) }}
              </template>

              <template v-slot:item.total_net_price_cash_total="{ item }">
                R$ {{ $format.decimal(item.total_net_price_cash_total) }}
              </template>

              <template v-slot:item.total_net_total="{ item }">
                R$ {{ $format.decimal(item.total_net_total) }}
              </template>
            </v-data-table>

            <app-pagination @click="select($event)" :data="products" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CompanySelect from "@/components/company/ui/CompanySelect.vue";
import MediaMixin from "@/mixins/Media/MediaMixin";
import { format, startOfMonth } from "date-fns";

export default {
  mixins: [MediaMixin],

  components: {
    CompanySelect,
  },

  data() {
    return {
      headers: [
        { text: "Produto", value: "product", align: "start" },
        {
          text: "A Entregar",
          value: "total_quantity_to_delivery",
          align: "end",
        },
        {
          text: "Entregues / Em Rota",
          value: "total_quantity_delivered",
          align: "end",
        },
        { text: "Total Líquido", value: "total_net_total", align: "end" },
        {
          text: "Preço à Vista",
          value: "total_net_price_cash_total",
          align: "end",
        },
      ],

      products: {
        data: [],
      },

      totals: {
        total_quantity_to_delivery: 0,
        total_net_total: 0,
        total_net_price_cash_total: 0,
      },

      searchParams: {
        company_ids: [],
        date_start: format(startOfMonth(new Date()), "yyyy-MM-dd"),
        date_end: format(new Date(), "yyyy-MM-dd"),
        delivery_status: ["not_delivered", "partial"],
        search: null,
      },

      isLoading: false,
    };
  },

  // mounted() {
  //   this.select(1);
  // },

  methods: {
    async select(page = 1) {
      this.searchParams.page = page;
      this.isLoading = true;

      try {
        const response = await this.$http.index(
          "sale/grouped-sale-product-to-deliver",
          this.searchParams
        );

        this.products = response.response;
        this.totals = response.totals || {
          total_quantity_to_delivery: 0,
          total_net_total: 0,
          total_net_price_cash_total: 0,
        };
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    handleSearchInput(search) {
      this.searchParams.search = search ? search : null;
      // this.select(1);
    },
  },
};
</script>
